import { render, staticRenderFns } from "./PageForgotPassword.vue?vue&type=template&id=8c7e2966&"
import script from "./PageForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./PageForgotPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports